import {CBadge, CButton, CCard, CCardBody, CCardHeader, CCardTitle, CCol, CContainer, CRow} from "@coreui/react";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {getApi} from "../../../apis/backendApis";
import useAlert from "../../../services/useAlert";
import CIcon from "@coreui/icons-react";


const UsuarioPlatformAccess= () => {

    const REDMINE = 'redmine';
    const MATTERMOST = 'mattermost';
    const INFOPANO = 'info-panorama';

    let location = useLocation();
    let idLocation = location.pathname.split('/');
    let idUsuario = idLocation[idLocation.length - 1];

    const [showAlert] = useAlert();

    const [usuarioTecnico, setUsuarioTecnico] = useState<boolean>(false)
    const [usuarioMaster, setMaster] = useState<boolean>(false)
    const [usuario, setUsuario] = useState<any>([])
    const [matterMostRegister, setMatterMostRegister] = useState<boolean>(false)
    const [matterMostAtivo, setMatterMostAtivo] = useState<boolean>(false)
    const [redmineRegister, setRedmineRegister] = useState<boolean>(false)
    const [redmineAtivo, setRedmineAtivo] = useState<boolean>(false)
    const [infoRegister, setInfoRegister] = useState<boolean>(false)
    const [infoAtivo, setInfoAtivo] = useState<boolean>(false)
    const [count, setCount] = useState(0);
    const [disableButton, setDisableButton] = useState(false);

    useEffect(() => {
        let api = getApi();
        api.get('/usuario/get/'+idUsuario).then((response =>{
            setUsuario(response.data)
            requestUsuarioTecnico();
            requestMattermost(api, response);
            requestRedmine(api, response);
            requestInfo(api, response);
        }))
    }, []);

    const requestUsuarioTecnico = () => {
       let api = getApi();
       api.get('/usuario/tecnico/'+idUsuario).then((response =>{
           if (response?.data?.isTecnico){
               setUsuarioTecnico(true);
               if (response?.data?.isMaster){
                   setMaster(true);
               }else{
                   setMaster(false);
               }
           }
           setCount((prevCount) => prevCount + 1);
       }))
    }

    const requestMattermost = (api: any, response: any) => {
        let formData = new FormData();
        formData.append('email', response?.data?.email);
        api.request({
            url: '/usuario/registrado/mattermost',
            method: "post",
            data: formData
        }).then((responseM: any) => {
            setCount((prevCount) => prevCount + 1);
            if (responseM.data.id){
                setMatterMostRegister(true);
                if (responseM?.data?.delete_at == 0 ){
                    setMatterMostAtivo(true);
                }
            }else{
                setMatterMostAtivo(false);
            }
        }).catch((error: any) => {
            setCount((prevCount) => prevCount + 1);
            setMatterMostRegister(false);
        })
    }

    const requestRedmine = (api: any, response: any) => {
        let formData = new FormData();
        formData.append('email', response?.data?.email);
        api.request({
            url: '/usuario/registrado/redmine',
            method: "post",
            data: formData
        }).then((responseR: any) => {
            setCount((prevCount) => prevCount + 1);
            if (responseR?.data?.user?.id){
                setRedmineRegister(true);
                if (responseR?.data?.user?.status){
                    setRedmineAtivo(true);
                }else{
                    setRedmineAtivo(false);
                }
            }else{
                setRedmineAtivo(false);
                setRedmineRegister(false);
            }
        }).catch((error: any) => {
            setCount((prevCount) => prevCount + 1);
        })
    }

    const requestInfo = (api: any, response: any) => {
        let formData = new FormData();
        formData.append('email', response?.data?.email);
        api.request({
            url: '/usuario/registrado/info-pano',
            method: "post",
            data: formData
        }).then((responseI: any) => {
            setCount((prevCount) => prevCount + 1);
            if (responseI?.data?.id){
                setInfoRegister(true);
                setInfoAtivo(true)
            }
        }).catch((error: any) => {
            setCount((prevCount) => prevCount + 1);
        })
    }

    const buttonAtivarOrRegister = (register:boolean, ativo: boolean, platform: string) =>{

        const registerUser = (platform: string) =>{
            let api = getApi();
            api.get('usuario/register/'+platform+'/'+usuario.id).then((response: any) => {
                if (response?.data?.success){
                    switch (response?.data?.platform){
                        case MATTERMOST:
                            setMatterMostRegister(true);
                            setMatterMostAtivo(true);
                        break;
                        case REDMINE:
                            setRedmineRegister(true);
                            setRedmineAtivo(true);
                        break;
                        case INFOPANO:
                            setInfoRegister(true);
                            setInfoAtivo(true);
                        break;
                    }
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'success',
                        toaster: true,
                    });
                }else{
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'danger',
                        toaster: true,
                    });
                }
                setDisableButton(false);
            })
        }

        const inativarUser = (platform: string) =>{
            let api = getApi();
            api.get('usuario/inativar/'+platform+'/'+usuario.id).then((response: any) => {
                if (response?.data?.success){
                    switch (response?.data?.platform){
                        case MATTERMOST:
                            setMatterMostAtivo(false);
                            break;
                        case REDMINE:
                            setRedmineAtivo(false);
                            break;
                        case INFOPANO:
                            setInfoRegister(false);
                            setInfoAtivo(false);
                            break;
                    }
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'success',
                        toaster: true,
                    });
                }else{
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'danger',
                        toaster: true,
                    });
                }
                setDisableButton(false);
            })
        }

        const ativarUser = (platform: string) =>{
            let api = getApi();
            api.get('usuario/ativar/'+platform+'/'+usuario.id).then((response: any) => {
                if (response?.data?.success){
                    switch (response?.data?.platform){
                        case MATTERMOST:
                            setMatterMostAtivo(true);
                            break;
                        case REDMINE:
                            setRedmineAtivo(true);
                            break;
                        case INFOPANO:
                            setInfoRegister(true);
                            setInfoAtivo(true);
                            break;
                    }
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'success',
                        toaster: true,
                    });
                }else{
                    showAlert({
                        msg: response?.data?.msg,
                        type: 'danger',
                        toaster: true,
                    });
                }
                setDisableButton(false);
            })
        }
        const handleClick = () => {
            setDisableButton(true);
            if (!register) {
                registerUser(platform);
            } else if (ativo) {
                inativarUser(platform);
            } else {
                ativarUser(platform);
            }
        };

        return (
            <div className={'d-flex justify-content-end align-items-center col-2 pr-5'}>
                <CButton style={{minWidth: 100, maxHeight: 35}} disabled={count < 4 || disableButton} color={'primary'} onClick={handleClick} className="d-flex align-items-center justify-content-center">
                    {count < 4 && <div style={{width:10, height: 10}} className={'spinner-border mr-1'}></div>}
                    {register ? (ativo ? 'Inativar' : 'Ativar') : 'Registrar'}
                </CButton>
            </div>
        );
    }

    const handleSetUsuarioTecnico = () => {
        let api = getApi();
        let formData = new FormData();
        formData.append('isMaster', usuarioMaster ? 'false' : 'true');
        api.request({
            url: '/usuario/tecnico/' + idUsuario,
            method: "post",
            data: formData
        }).then((response: any) => {
            if (response?.data?.success) {
                requestUsuarioTecnico()
                showAlert({
                    'msg': response?.data?.msg,
                    'type': 'success',
                    'toaster': true,
                })
            } else {
                showAlert({
                    'msg': response?.data?.msg,
                    'type': 'danger',
                    'toaster': true,
                })
            }
        })
    }

    return (
        <CContainer>
            <div className="row font-2xl ml-1 mb-3">
                {(usuario.nome) ? usuario.nome : 'Carregando ...'}
            </div>
            <CCard>
                <CCardHeader>
                <CRow>
                    <CCol>
                        <div className={'d-flex align-items-center'}>
                            <div>
                                <img
                                    src="img/mattermost.png"
                                    alt="Mattermost"
                                    style={{height: 40, width: 40}}
                                />
                            </div>
                            <div className={'pl-2 text-value-lg'}>Mattermost</div>
                        </div>
                    </CCol>
                    <CCol>
                        <div className={'font-lg'}>Usuário Registrado?</div>
                        <CBadge className={'font-lg'}
                                color={matterMostRegister ? 'success' : 'danger'}>{matterMostRegister ? 'Registrado' : 'Sem Registro'}</CBadge>
                    </CCol>
                    <CCol>
                          <div className={'font-lg'}>Usuário Ativo?</div>
                          <CBadge  className={'font-lg'} color={matterMostAtivo ? 'success' : 'danger'}>{matterMostAtivo ? 'Ativo' : 'Inativo'}</CBadge>
                    </CCol>
                  </CRow>
              </CCardHeader>
              <CCardBody size={10}>
                  <CRow>
                      <div className={'col'}>O Mattermost é uma plataforma de chat corporativo que facilita a
                          comunicação,
                          colaboração e integração de equipes com segurança e controle total dos dados.
                      </div>
                      {buttonAtivarOrRegister(matterMostRegister, matterMostAtivo, MATTERMOST)}
                  </CRow>
              </CCardBody>
          </CCard>
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol className="d-flex align-items-center">
                            <div>
                                <img
                                    src="img/redmine.png"
                                    alt="Redmine"
                                    className="flex-shrink-0"
                                    style={{height: 40, width: 40}}
                                />

                            </div>
                            <div className={'pl-3 text-value-lg'}>Redmine</div>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Registrado?</div>
                            <CBadge className={'font-lg'} color={redmineRegister ? 'success' : 'danger'}>{redmineRegister ? 'Registrado' : 'Sem Registro'}</CBadge>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Ativo?</div>
                            <CBadge  className={'font-lg'} color={redmineAtivo ? 'success' : 'danger'}>{redmineAtivo ? 'Ativo' : 'Inativo'}</CBadge>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody size={10}>
                    <CRow>
                        <div className={'col'}>
                            O Redmine é uma ferramenta de gestão de projetos e tarefas, permitindo acompanhamento de demandas,
                            controle de tempo e colaboração entre equipes de forma organizada e eficiente.
                        </div>
                        {buttonAtivarOrRegister(redmineRegister, redmineAtivo, REDMINE)}
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol className="d-flex align-items-center">
                            <div>
                                <img
                                    src="img/panoramasistemas.svg"
                                    alt="Info"
                                    className="flex-shrink-0"
                                    style={{height: 40, width: 40}}
                                />
                            </div>
                            <div className={'pl-2 text-value-lg'}>Info Panorama Sistemas</div>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Registrado?</div>
                            <CBadge className={'font-lg'} color={infoRegister ? 'success' : 'danger'}>{infoRegister ? 'Registrado' : 'Sem Registro'}</CBadge>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Ativo?</div>
                            <CBadge  className={'font-lg'} color={infoAtivo ? 'success' : 'danger'}>{infoAtivo ? 'Ativo' : 'Inativo'}</CBadge>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody size={10}>
                    <CRow>
                        <div className={'col'}>
                            Ferramenta para organizar conteúdo em quatro níveis: estantes, livros, capítulos e páginas, facilitando a estruturação da informação.
                        </div>
                        {buttonAtivarOrRegister(infoRegister, infoAtivo, INFOPANO)}
                    </CRow>
                </CCardBody>
            </CCard>
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol className="d-flex align-items-center">
                            <div>
                                <CIcon name="cilLockLocked" size={'xl'}></CIcon>
                            </div>
                            <div className={'pl-2 text-value-lg'}>Acesso Técnico</div>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Registrado?</div>
                            <CBadge className={'font-lg'} color={usuarioTecnico ? 'success' : 'danger'}>{usuarioTecnico ? 'Registrado' : 'Sem Registro'}</CBadge>
                        </CCol>
                        <CCol>
                            <div className={'font-lg'}>Usuário Master?</div>
                            <CBadge  className={'font-lg'} color={usuarioMaster ? 'success' : 'danger'}>{usuarioMaster ? 'Ativo' : 'Inativo'}</CBadge>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody size={10}>
                    <CRow>
                        <div className={'col'}>
                            O Acesso Técnico é um usuário com permissões para suporte e manutenção.
                        </div>
                        <div className={'col-2 pr-5 d-flex justify-content-end align-items-center'}>
                            <CButton style={{minWidth: 100, maxHeight: 35}} disabled={count < 4 || disableButton} color={'primary'} onClick={handleSetUsuarioTecnico} className="d-flex align-items-center justify-content-center">
                                {count < 4 && <i style={{width:10, height: 10}} className={'spinner-border mr-1'}></i>}
                                {usuarioTecnico ? (usuarioMaster ? 'Técnico' : 'Master') : 'Registrar'}
                            </CButton>
                        </div>
                    </CRow>
                </CCardBody>
            </CCard>
        </CContainer>
    )
}
export default UsuarioPlatformAccess;